import { PatsnapCopilotIntentRendererContribution, PatsnapCopilotIntentRendererRegistry, PatsnapCopilotIntentRendererRegistryImpl } from '@analytics/patsnap-copilot/src/patsnap-copilot-renderer';
import { PatsnapCopilotService } from '@analytics/patsnap-copilot/src/patsnap-copilot-service.interface';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { PatsnapCopilotServiceImpl } from './patsnap-copilot-service';
import { PatsnapCopilotMessageSender, PatsnapCopilotMessageSenderImpl } from '@analytics/patsnap-copilot/src/patsnap-copilot-message-sender';
import { VueBaseExternalIntentRenderer, VueBaseExternalIntentRendererImpl } from '@analytics/patsnap-copilot/src/vue-base-external-intent-renderer';
import { WuJieBus } from '@analytics/patsnap-copilot/src/wujie-bus';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import WujieVue from 'wujie-vue2';
import { CoreSearchApiServiceImpl } from '@/infrastructure/api-functions/core-search-api/impls/core-search-api';
import { GetSocketPath, GetSocketPathImpl } from '@analytics/shared/services/socket-path';
import { SearchSocketJob } from '@analytics/shared/apis/core-search-api-service.interface';
import { PatentViewCopilotContext, PatentViewCopilotContextImpl } from './patent-view-copilot-context';
import { PatsnapCopilotFeedBackService, PatsnapCopilotFeedBackServiceImpl } from '@analytics/shared/services/patsnap-copilot-feedback-service';
import { ApiCopilotFeedback, ApiCopilotInit } from '@analytics/shared/apis/core-basic-api-service.interface';
import { CoreBasicApiServiceImpl } from '@analytics/shared/apis/core-basic-api-service';
import { ParagraphHighlightService } from './paragraph-highlight-service.interface';
import { ParagraphHighlightServiceImpl } from './paragraph-highlight-service';
import { PatsnapCopilotDialogSize, PatsnapCopilotDialogSizeImpl } from '@analytics/patsnap-copilot/src/patsnap-copilot-dialog-size';
import { CopilotHelpService, CopilotHelpServiceImpl } from '@analytics/shared/services/copilot-help-service';

export function patsnapCopilotModule(bind: interfaces.Bind) {
    // #region 以下代码是复制自 @analytics/patsnap-copilot/src/patsnap-copilot-module.ts
    const { bus } = WujieVue;
    bind(WuJieBus).toConstantValue(bus);
    bind(PatsnapCopilotMessageSender).to(PatsnapCopilotMessageSenderImpl);
    bind(VueBaseExternalIntentRenderer).to(VueBaseExternalIntentRendererImpl);
    bindContributionProvider(bind, PatsnapCopilotIntentRendererContribution);
    bind(PatsnapCopilotIntentRendererRegistry).to(PatsnapCopilotIntentRendererRegistryImpl);
    // #endregion

    // #region 以下代码是项目中的代码
    bind(SearchSocketJob).to(CoreSearchApiServiceImpl);
    bind(GetSocketPath).to(GetSocketPathImpl);
    bind(PatsnapCopilotFeedBackService).to(PatsnapCopilotFeedBackServiceImpl);
    bind(ApiCopilotFeedback).to(CoreBasicApiServiceImpl);
    bind(ApiCopilotInit).to(CoreBasicApiServiceImpl);
    bind(PatentViewCopilotContext).to(PatentViewCopilotContextImpl);
    bind(ParagraphHighlightService).to(ParagraphHighlightServiceImpl);
    bind(PatsnapCopilotService).to(PatsnapCopilotServiceImpl);
    bind(PatsnapCopilotDialogSize).to(PatsnapCopilotDialogSizeImpl);
    bind(CopilotHelpService).to(CopilotHelpServiceImpl);
    // #endregion
}
